/**
 * This module was ported from SB2 to resolve #9527 and replace the dependency
 * on move-decimal-point npm module
 *
 */

import _ from 'lodash'


/**
 * Shifts the decimal place of the given number the given number of places to the right;
 * negative number will cause a shift to the left. Safer than multiplying by powers of
 * 10, because binary floating point arithmetic can cause things like .14 * 100 to be 14.000000000000002
 *
 * @param val {Number|string} A numeric value, can be a string but must be a valid numeric value
 * @param places {Number} number of places to shift the decimal, can be negative to shift left
 * @throws Error if val is not numeric
 */
var moveDecimal = function (val, places) {
	if (val === null || val === undefined) {
		return val
	}

	if (typeof val == 'number' && isNaN(val)) {
		return val
	}

	var numVal = _.toNumber(val)
	if (isNaN(numVal)) {
		throw new Error('value must be a Number:' + val)
	}

	if (val >= 0) {
		var valstr = val.toString()
	} else {
		var negative = true
		var valstr = Math.abs(val).toString()
	}

	var decimalIndex = valstr.indexOf('.')
	if (decimalIndex === -1) {
		decimalIndex = valstr.length
		valstr += '.0'
	}

	var noDecimal = valstr.substring(0, decimalIndex) + valstr.substring(decimalIndex+1)

	var newDecimalIndex = decimalIndex + places
	var absResult
	if (newDecimalIndex >= noDecimal.length) {
		var padding = newDecimalIndex - noDecimal.length
		absResult = Number(noDecimal + _zeros(padding))
	} else if (newDecimalIndex < 0) {
		absResult = Number('.' + _zeros(Math.abs(newDecimalIndex)) + noDecimal)
	} else {
		absResult = Number(noDecimal.substring(0, newDecimalIndex) + '.' + noDecimal.substring(newDecimalIndex))
	}

	return negative ? -absResult : absResult
}

/**
 * Returns a String with the given number of zeroes
 */
function _zeros (num) {
	return _.times(num, _.constant(0)).join('')
}

export default moveDecimal

moveDecimal.__filename__ = 'components/move-decimal.js'
